import { gsap } from "../utilities/gsap";

export default function Numcounter() {
    jQuery(function($){        
        //get stats in array to process one by one
        let stats = $(".numcounter").toArray();

        stats.forEach(_element => {
            ( async ( element ) => 
            {
                countOne( element );
            } )( _element );
        });
        
        //recursive function
        function countOne(stat) {
            // let stat = stats.shift(); //remove first
    
            var count = $(stat),
            zero = {
                val: 0
            },
            num = count.data("number"),
            split = (num + "").split("."), // to cover for instances of decimals
            decimals = split.length > 1 ? split[1].length : 0;
        
            //if it's not a number then skip counting
            if (typeof num == 'number') {
            gsap.to(zero, {
                val: num,
                duration: 4,
                scrollTrigger : {
                    trigger: stat,
                    invalidateOnRefresh: true
                },
                onUpdate: function() {
                    let numText = zero.val.toFixed(decimals)
                    numText = numText.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    count.text(numText);
                },
                onComplete: function() {
                }
            });
        
            } else {
                count.text(num);
            }
        }
    });
}